//service
import http from "./httpService";
import config from "./config"


export const isShow = () => {
    return http.get(
        `${config.apiAddress}cTest/isShow`,
    );
};




//service 
export const payment = (user) => {
    return http.get(
        `${config.apiAddress}cTest/checkExam/${user}`,
    );
};

export const numberTest = (user) => {
    return http.get(
        `${config.apiAddress}cTest/testNumber/${user}`,
    );
};


export const startTest = (user) => {
    return http.get(
        `${config.apiAddress}cTest/startTest/${user}`,
    );
};



export const checkStartExam = (user) => {
    return http.get(
        `${config.apiAddress}cTest/checkStartExam/${user}`,
    );
};


export const getExam = (user) => {
    return http.get(
        `${config.apiAddress}cTest/getExam/${user}`,
    );
};


export const endExam = (user,mark,examId,isPassed) => {
    return http.get(
        `${config.apiAddress}cTest/endExam/${user}/${mark}/${examId}/${isPassed}`,
    );
};


export const numberChance = (user) => {
    return http.get(
        `${config.apiAddress}cTest/numberChance/${user}`,
    );
};


export const checkChance = (user) => {
    return http.get(
        `${config.apiAddress}cTest/checkChance/${user}`,
    );
};



export const setOff = (user,offIndex) => {
    return http.get(
        `${config.apiAddress}cTest/setOff/${user}/${offIndex}`,
    );
};


export const getOff = () => {
    return http.get(
        `${config.apiAddress}cTest/getOff`,
    );
};



export const getMyOff = (user) => {
    return http.get(
        `${config.apiAddress}cTest/getMyOff/${user}`,
    );
};